import React, { useMemo } from 'react';

import { useChildComponent } from '@gogame/hooks-ts';
import DataGrid from '@gogame/data-grid';
import {
  SET_TABLE_SETTINGS,
  useScreenState,
  useScreenDispatch,
  useScreenTitle,
} from '@gogame/screens';

import { CategoryFormEdit } from 'scenes/GalleryTags/components/CategoryForm';
import { useLoadTable, useIsUpdating } from 'scenes/GalleryTags/data';
import Toolbar from 'scenes/GalleryTags/components/GalleryTagsDataTable/Toolbar';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_TYPE,
  COLUMN_IS_MULTISELECT,
  COLUMN_BANNER,
  COLUMN_GIF,
  COLUMN_VIDEO,
  COLUMN_CINEMAGRAPH,
  COLUMN_PLAYABLE,
  COLUMN_TAGS,
} from 'scenes/GalleryTags/constants';
import {
  COLLAPSE_COLUMNS,
  REORDER_COLUMNS,
} from 'scenes/GalleryTags/screenReducer';
import GalleryTagsActions from 'scenes/GalleryTags/components/Actions';

export default () => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();

  const { data, isLoading, isRefetching } = useLoadTable(screenState);
  const isUpdating = useIsUpdating();

  const [childComponent, openChildComponent] = useChildComponent();
  const [screenTitle] = useScreenTitle();

  const handleEdit = (category) => {
    openChildComponent(CategoryFormEdit, {
      id: category.id,
    });
  };

  const handleChangeSettings = (settings) => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: settings,
    });
  };

  const handleReorder = (order) => {
    dispatch({
      type: REORDER_COLUMNS,
      payload: order,
    });
  };

  const handleCollapse = (collapsed) => {
    dispatch({
      type: COLLAPSE_COLUMNS,
      payload: collapsed,
    });
  };
  return (
    <React.Fragment>
      <DataGrid
        rows={data?.rows}
        count={data?.count}
        title={screenTitle}
        loading={isLoading || isUpdating}
        fetching={isRefetching}
        onChangeSettings={handleChangeSettings}
        onReorder={handleReorder}
        onCollapse={handleCollapse}
        tableSettings={screenState.tableSettings}
        columnsState={screenState.columns}
        toolbar={<Toolbar />}
        storageKey={'galleryTags'}
        defaultColumnWidth={110}
      >
        <DataGrid.Column
          field={COLUMN_ID}
          type={'text'}
          headerName={'ID'}
          width={70}
          fixed={true}
          resizable={false}
          align={'right'}
          headerAlign={'right'}
          sortable={false}
        />
        <DataGrid.Column
          field={COLUMN_NAME}
          type={'text'}
          headerName={'Category'}
          width={200}
          sortable={false}
        />
        <DataGrid.Column
          field={COLUMN_TYPE}
          type={'text'}
          headerName={'Type'}
          sortable={false}
        />
        <DataGrid.Column
          field={COLUMN_IS_MULTISELECT}
          type={'text'}
          headerName={'Multiselect'}
          sortable={false}
          getValue={(value) => (value ? 'Yes' : 'No')}
        />
        <DataGrid.Column
          field={COLUMN_BANNER}
          type={'text'}
          headerName={'Banner'}
          sortable={false}
        />
        <DataGrid.Column
          field={COLUMN_GIF}
          type={'text'}
          headerName={'Gif'}
          sortable={false}
        />
        <DataGrid.Column
          field={COLUMN_VIDEO}
          type={'text'}
          headerName={'Video'}
          sortable={false}
        />
        <DataGrid.Column
          field={COLUMN_CINEMAGRAPH}
          type={'text'}
          headerName={'Cinemagraph'}
          sortable={false}
        />
        <DataGrid.Column
          field={COLUMN_PLAYABLE}
          type={'text'}
          headerName={'Playable'}
          sortable={false}
        />
        <DataGrid.Column
          field={COLUMN_TAGS}
          type={'text'}
          headerName={'Tags'}
          minWidth={400}
          flex={1}
          sortable={false}
          getValue={(value) => value?.map((tag) => tag.name).join(', ')}
        />
        <DataGrid.Column
          actionsColDef
          type={'actions'}
          actionsComponent={GalleryTagsActions}
          onEdit={handleEdit}
          limit={2}
        />
      </DataGrid>
      {childComponent}
    </React.Fragment>
  );
};
